import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SITE_NAME = "Inkstead";
export const DEFAULT_DESCRIPTION =
  "Inkstead is a community platform for the tattoo world: discover artists, explore portfolios, book sessions and read stories.";

// Set REACT_APP_SITE_URL (e.g. https://your-domain.com) at build time. No domain is
// hard-coded: when unset, canonical / og:url / absolute image URLs are omitted.
const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/+$/, "");

const absolute = (value) => {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;
  return SITE_URL ? `${SITE_URL}${value.startsWith("/") ? "" : "/"}${value}` : undefined;
};

export default function Seo({ title, description = DEFAULT_DESCRIPTION, path, image, type = "website", noindex = false }) {
  const { pathname } = useLocation();
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} – Tattoo artists, portfolios & community`;
  const canonical = noindex || !SITE_URL ? undefined : `${SITE_URL}${path ?? pathname}`;
  const img = absolute(image);
  const robots = noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {canonical && <meta property="og:url" content={canonical} />}
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
}
